const options = {
  debounceTime: 1000,
  dateFormat: 'DD.MM.YYYY',
  dateTimeFormat: 'DD.MM.YYYY HH:mm',
};

const config = {
  iPortalProduction: {
    API_URL: process.env.REACT_APP_I_PORTAL_PRODUCTION_URL,
    options,
  },
  iAppProduction: {
    API_URL: process.env.REACT_APP_I_APP_PRODUCTION_URL,
    options,
  },
  demo: {
    API_URL: process.env.REACT_APP_DEMO_URL,
    options,
  },
  dev: {
    API_URL: process.env.REACT_APP_DEV_URL,
    options,
  },
};

export const allConfig = config;

export const environmentConfig = 'iAppProduction';

export default config[environmentConfig] ?? config.production;
